import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const Video = styled.video`
  height: 100%;
  width: 100%;
  position: absolute;
`;

/**
 * localStream is passed down from Add/GoLive screen, in order to
 * make the switch between components and ready for display faster
 */
const LocalVideo = ({ localStream }) => {
  const [stream, setStream] = useState(localStream);
  const videoRef = useRef();

  useEffect(() => {
    // Attach the stream to video
    const videoEl = document.getElementById('host-local-stream');
    videoEl.srcObject = stream;
    videoEl.play();
  }, []);

  return <Video ref={videoRef} id="host-local-stream" hasStream={stream} muted />;
};

export default LocalVideo;
